// extracted by mini-css-extract-plugin
export default {"summaryTextfield":"TotalSumInput_summaryTextfield__vrwJI","disabled":"TotalSumInput_disabled__p6CEf"};